// extracted by mini-css-extract-plugin
module.exports = {"title":"DialogTitle_title__XgpI4","headline":"DialogTitle_headline__1l2B5"};